import { useInfiniteQuery } from '@tanstack/vue-query';
import { type MaybeRefOrGetter, toRef, toValue } from 'vue';
import type { OffersControllerGetOffersData } from '@carvia/ros-client-types';
import { offersService } from '@/api/offers.service';

const QUERY_KEY = 'offers';

export const useOffers = (
  query: MaybeRefOrGetter<OffersControllerGetOffersData['query']>,
  enabled: MaybeRefOrGetter<boolean> = true,
) => {
  return useInfiniteQuery({
    queryKey: [QUERY_KEY, toRef(query)],
    queryFn: ({ pageParam = 1 }) => {
      const queryValue = toValue(query);
      return offersService.getOffers({
        ...queryValue,
        includeHidden: queryValue.includeHidden ?? true,
        page: pageParam,
      });
    },
    enabled: toRef(enabled),
    getNextPageParam: (lastPage) => lastPage.meta.nextPage,
    initialPageParam: 1,
  });
};
